// extracted by mini-css-extract-plugin
module.exports = {"NavigationLogo":"styles_NavigationLogo__CqhEv","blackTheme":"styles_blackTheme__9nS3s","whiteTheme":"styles_whiteTheme__fftif"};